import React, { useState } from 'react';
import { Row, Col, Form, Spinner } from 'reactstrap';
import Select from 'react-select';
import { DateRangePicker } from 'rsuite';
import moment from 'moment';
import toast from 'react-hot-toast';
import { SHOWROOM_NAMES } from '../../../../constants/showRoomCodes';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import UserAuthKey from '../../../../components/Common/UserAuthKey';

const apiUrl = process.env.REACT_APP_OMS_API;
const ManageBankRefundExport = () => {
    const [status, setStatus] = useState(null);
    const [store, setStore] = useState(null);
    const [startDate, setStartDate] = useState(
        new moment(new Date()).format('YYYY-MM-DD')
    );
    const [endDate, setEndDate] = useState(
        new moment(new Date()).format('YYYY-MM-DD')
    );
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    let UserRoleID = '';
    let UserCountry = '';
    let UserStore = '';

  if (localStorage.getItem('authUser')) {
    const userObj = JSON.parse(localStorage.getItem('authUser'));
    if (userObj?.role_id !== undefined) {
      UserRoleID = userObj?.role_id;
      UserCountry = userObj?.country;
      UserStore = userObj?.stores;  
    }
  }

    const statusOptions = [
        { value: '', label: 'All' },
        { value: '0', label: 'Pending' },
        { value: '2', label: 'Approved' },
        { value: '3', label: 'Completed' },
        { value: '5', label: 'Rejected' },
        { value: '6', label: 'Closed' },
        { value: '7', label: 'Pending CS Manager' },
        { value: '8', label: 'Pending Show Room Manager' },
        { value: '9', label: 'Finance Approval Pending' },
        { value: '10', label: 'Finance Manager Approval Pending' },
        { value: '20', label: 'Audit Approval Pending' },
        { value: '11', label: 'Finance Rejected' },
        { value: '12', label: 'Show Room Manager Approved' },
        { value: '13', label: 'Show Room Manager Rejected' },
        { value: '14', label: 'Customer Service Manager Approved' },
        { value: '15', label: 'Customer Service Manager Rejected' },
    ];

    // Build storeOptions from SHOWROOM_NAMES (use key as value for matching)
    let storeOptions = Object.entries(SHOWROOM_NAMES).map(([key, label]) => ({ value: key, label }));

    // Restrict storeOptions based on UserRoleID and UserStore
    if (UserRoleID !== '1' && UserStore) {
        const userStoresArr = Array.isArray(UserStore)
            ? UserStore
            : String(UserStore).split(',').map(s => s.trim());
        storeOptions = storeOptions.filter(opt => userStoresArr.includes(opt.value));
    }

    const excelGenerate = async (params) => {
        const bearerToken = UserAuthKey();
        const config = {
            method: 'POST',
            url: `${apiUrl}v1/orders/other_export_result`,
            headers: {
                Authorization: `Bearer ${bearerToken}`,
                'Content-Type': 'application/json',
            },
            data: {
                ...params,
            },
        };
        try {
            const response = await axios(config);
            setLoading(false);
            if (response?.data?.data?.[0]?.report_link) {
                toast.success('Export successful!');
                window.location.href = response.data.data[0].report_link;
            } else {
                toast.error('Export failed. No report link found.');
            }
        } catch (error) {
            setLoading(false);
            toast.error('Export failed.');
            console.log(error);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!status || !store) {
            toast.error('Please select both Status and Store.');
            return;
        }
        setLoading(true);
        const storeCode = store.value;
        excelGenerate({
            export_type: 'bank_transfer_refund',
            date_from: startDate,
            date_to: endDate === undefined || endDate === '' ? startDate : endDate,
            country: 'ae',
            status: status?.value ?? '',
            storeCode
        });
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Row className="align-items-center justify-content-between" style={{ height: '100%' }}>
                <Col xs="12" sm="6" md="4">
                    <Select
                        options={statusOptions}
                        placeholder="Select Status"
                        onChange={(selectedOption) => setStatus(selectedOption)}
                    />
                </Col>
                <Col xs="12" sm="6" md="3">
                    <Select
                        options={storeOptions}
                        placeholder="Select Store"
                        onChange={(selectedOption) => setStore(selectedOption)}
                    />
                </Col>
                <Col xs="12" sm="6" md="3">
                    <DateRangePicker
                        placeholder="Select Date Range"
                        placement="auto"
                        onChange={(selectedDates) => {
                            const start = moment(selectedDates[0]).format('YYYY-MM-DD');
                            const end = moment(selectedDates[1]).format('YYYY-MM-DD');
                            setStartDate(start);
                            setEndDate(end);
                        }}
                    />
                </Col>
                <Col xs="12" sm="6" md="2">
                    <button type="submit" className="btn btn-dark w-100" disabled={loading} style={{ display: 'flex' }}>
                        {loading ? <Spinner size="sm" /> : 'Export'}
                        <i className="bx bx-download" style={{ padding: '3px' }}></i>
                    </button>
                </Col>
            </Row>
        </Form>
    );
};

export default ManageBankRefundExport;
